module.exports = require('./_hide');



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/modules/_redefine.js
 ** module id = 332
 ** module chunks = 1
 **/